import * as React from "react";
import classnames from "classnames";
import { useIntl } from "@grandvisionhq/state";
import { isNil } from "@grandvisionhq/utils";
/* empty css                       */
import { PrescriptionKey, PrescriptionSide } from "../../../../../models/line-item/LineItems/models/line-item/prescription.js";
const EYE_SIDES = [PrescriptionSide.Right, PrescriptionSide.Left];
const dataOrDash = (prescription, key, eye) => {
  if (!eye) {
    return prescription[key] ?? "-";
  } else {
    return prescription[eye]?.[key] ?? "-";
  }
};
const CLASS_PREFIX = "prescription-table";
const hasEyeSide = (prescription) => {
  return Boolean(prescription.leftEye || prescription.rightEye);
};
const isKeyMissing = (prescription, key) => {
  return prescription.rightEye?.[key] ?? prescription.leftEye?.[key] ?? prescription?.[key];
};
const TableEyeSideTop = ({
  keys,
  prescription,
  className,
  labelFormatter,
  "aria-label": ariaLabel,
  size = "normal"
}) => {
  const { getLabel } = useIntl();
  const classes = classnames(
    className,
    `${CLASS_PREFIX} ${CLASS_PREFIX}--${size} ${CLASS_PREFIX}--cols-3`
  );
  return /* @__PURE__ */ React.createElement("table", { className: classes, "aria-label": ariaLabel }, /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", null, ""), hasEyeSide(prescription) ? EYE_SIDES.map((eyeSide) => /* @__PURE__ */ React.createElement("th", { key: `header-${eyeSide}`, scope: "col" }, getLabel(`products.contactLenses.${eyeSide}`))) : null)), /* @__PURE__ */ React.createElement("tbody", null, keys.map(
    (key) => !isNil(isKeyMissing(prescription, key)) ? /* @__PURE__ */ React.createElement("tr", { key }, /* @__PURE__ */ React.createElement("th", { scope: "row", className: "text--capitalize" }, labelFormatter(key)), hasEyeSide(prescription) ? EYE_SIDES.map((eyeSide) => /* @__PURE__ */ React.createElement("td", { key: `cell-${eyeSide}-${key}` }, dataOrDash(prescription, key, eyeSide))) : /* @__PURE__ */ React.createElement("td", { key: `cell-${key}` }, prescription && dataOrDash(prescription, key))) : null
  )));
};
const TableEyeSideLeft = ({
  keys,
  prescription,
  className,
  labelFormatter,
  "aria-label": ariaLabel,
  size = "normal"
}) => {
  const { getLabel } = useIntl();
  const classes = classnames(
    className,
    `${CLASS_PREFIX} ${CLASS_PREFIX}--${size} ${CLASS_PREFIX}--cols-${keys.length + 1}`
  );
  return /* @__PURE__ */ React.createElement("table", { className: classes, "aria-label": ariaLabel }, /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", null, hasEyeSide(prescription) ? /* @__PURE__ */ React.createElement("td", null, "") : null, keys.map(
    (key) => isKeyMissing(prescription, key) ? /* @__PURE__ */ React.createElement("th", { key, scope: "col", className: "text--capitalize" }, labelFormatter(key)) : null
  ))), /* @__PURE__ */ React.createElement("tbody", null, hasEyeSide(prescription) ? EYE_SIDES.map((eyeSide) => /* @__PURE__ */ React.createElement("tr", { key: `row-${eyeSide}` }, /* @__PURE__ */ React.createElement("th", { scope: "row" }, getLabel(`products.contactLenses.${eyeSide}`)), keys.map(
    (key) => isKeyMissing(prescription, key) ? /* @__PURE__ */ React.createElement("td", { key }, dataOrDash(prescription, key, eyeSide)) : null
  ))) : keys.map(
    (key) => isKeyMissing(prescription, key) ? /* @__PURE__ */ React.createElement("td", { key }, dataOrDash(prescription, key)) : null
  )));
};
const PrescriptionTable = (props) => {
  const { getLabel } = useIntl();
  const keys = [
    PrescriptionKey.Power,
    PrescriptionKey.BaseCurve,
    PrescriptionKey.Diameter,
    PrescriptionKey.Cylinder,
    PrescriptionKey.Axis,
    PrescriptionKey.Addition,
    PrescriptionKey.PupillaryDistance,
    PrescriptionKey.Prism,
    PrescriptionKey.Dominance
  ];
  const getAbbreviatedLabel = (propertyName) => getLabel(`products.contactLenses.prescription.${propertyName}.abbr`);
  const tableProps = {
    keys,
    labelFormatter: getAbbreviatedLabel,
    ...props
  };
  return props.orientation === "eyeSideTop" ? /* @__PURE__ */ React.createElement(TableEyeSideTop, { ...tableProps }) : /* @__PURE__ */ React.createElement(TableEyeSideLeft, { ...tableProps });
};
export {
  PrescriptionTable,
  PrescriptionTable as default
};
//# sourceMappingURL=PrescriptionTable.js.map
